module.exports = __webpack_public_path__ + "static/img_1227-6d5f0e02a6ddee68b9082314d95c421f.webp";